import { Injectable } from '@angular/core';
import { LoadingController, AlertController } from 'ionic-angular';
import { UserData } from '../../../../providers/user-data';
import { PageRef } from '../../../../core/core.module';

@Injectable()
export class ForgotPasswordCommon {
	
	public currentUser: any;
	public nameInitials: string;
	
	constructor(
		public loadingCtrl: LoadingController,
		public userData: UserData,
    	public pageRef: PageRef,
    	public alertCtrl: AlertController,
	) {


	}

	public commonMethod(){
		console.log("Hello Forgot Password");
	}

	public requestResetPassword(form, forgotPass, nav, errorMsg){
    	this.userData.sendPasswordResetEmail(forgotPass.email).subscribe((res)=>{
    		let alert;
    		if(!res.success){
                errorMsg=res.msg;
    			return false;
    		}
            errorMsg = '';
    		alert = this.alertCtrl.create({
    			title: '',
    			subTitle: 'Password reset link has been sent to your email address',
    			buttons: [{
                    text: 'OK',
                    handler: data=>{
                        nav.pop();
                    }
                }]

    		});
    		alert.present();
    	});
	}
}



// WEBPACK FOOTER //
// ./src/modules/account/pages/forgot-password/forgot-password.common.ts